import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { putBattery } from '../Api'

export default generateApiAction({
  baseType: Types.BATTERIES.PUT,
  api: putBattery,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/batteries/PutAction.js